import { customCreateEnum } from './enum/enumArray'

// 订单履约列表使用
const orderStateList = [
  {
    label: '待履约',
    value: '1',
  },
  {
    label: '履约中',
    value: '2',
  },
  {
    label: '待验收',
    value: '3',
  },
  {
    label: '已完成',
    value: '4',
  },
  {
    label: '已取消',
    value: '5',
  },
  {
    label: '已退货',
    value: '6',
  },
  //   暂时没有用到
  {
    label: '已撤回',
    value: '7',
  },
] as const

export const orderStateEnum = customCreateEnum(orderStateList)

// 客户开票状态，在可对账订单列表用到
const customInvoiceList = [
  {
    label: '已开票',
    value: '1',
  },
  {
    label: '未开票',
    value: '2',
  },
  {
    label: '开票中',
    value: '3',
  },
]

export const customInvoiceEnum = customCreateEnum(customInvoiceList)
import { customCreateEnum } from './enum/enumArray'

// 订单履约列表使用
const orderStateList = [
  {
    label: '待履约',
    value: '1',
  },
  {
    label: '履约中',
    value: '2',
  },
  {
    label: '待验收',
    value: '3',
  },
  {
    label: '已完成',
    value: '4',
  },
  {
    label: '已取消',
    value: '5',
  },
  {
    label: '已退货',
    value: '6',
  },
  //   暂时没有用到
  {
    label: '已撤回',
    value: '7',
  },
] as const

export const orderStateEnum = customCreateEnum(orderStateList)

// 客户开票状态，在可对账订单列表用到
const customInvoiceList = [
  {
    label: '已开票',
    value: '1',
  },
  {
    label: '未开票',
    value: '2',
  },
  {
    label: '开票中',
    value: '3',
  },
]

export const customInvoiceEnum = customCreateEnum(customInvoiceList)
